import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import { IconButton } from "@mui/material";
import * as React from "react";
import { GetTreeHasObject, TreeContext } from "../../../../Redux/Reducers/redux-slice-tree";
import { useAppSelector } from "../../../../Redux/redux-store";
import { useToggle } from "../../../../Utils/Hooks/useToggle";
import TitleTreeViewPanel from "../../../TreeView/TreeViewPanel/tree-view-panel";

export interface PageHeadTreeviewProps {}

const PageHeadTreeview: React.FC<PageHeadTreeviewProps> = (props) => {
  const { active: treeViewPanelOpen, toggle: toggleTreeViewPanel, unactivate: closeTreeViewPanel } = useToggle(false);

  const isOjectInitialized = useAppSelector(GetTreeHasObject(TreeContext.TitlePanel));

  return (
    <>
      {isOjectInitialized && (
        <>
          <IconButton color="ghost" size="small" onClick={toggleTreeViewPanel}>
            <AccountTreeOutlinedIcon />
          </IconButton>
          <TitleTreeViewPanel open={treeViewPanelOpen} onClose={closeTreeViewPanel} />
        </>
      )}
    </>
  );
};

export default PageHeadTreeview;
